// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('BottomCallToActionSection')

function BottomCallToActionSection(props) {
  const onButtonClick = props.isSULandingPage
    ? props.onSULoginClick
    : props.onSignupClick
  return tag('div', {
    className: bem.block()
  },
    tag('div', {
      className: bem.element('content')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Curate the`,
        tag('br'),
        `best of the internet`
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        `You can save anything from anywhere.`,
        tag('br'),
        `Mix learns what you love to show you even more.`
      ),
      tag('div', {
        className: bem.element('buttons-container')
      },
        tag('button', {
          className: bem.element('button', 'primary'),
          onClick: onButtonClick
        },
          `Join Mix`
        )
      )
    ),
    tag('div', {
      className: bem.element('image')
    })
  )
}

BottomCallToActionSection.propTypes = {
  // Flags
  isSULandingPage: PropTypes.bool.isRequired,
  // Callbacks
  onSignupClick: PropTypes.func.isRequired,
  onSULoginClick: PropTypes.func.isRequired
}

module.exports = BottomCallToActionSection
